"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalEditorialLandingPageQuery = void 0;
var _fetching = require("@ori/fetching");
var _personalEditorialCategoryPageFragment = require("./personalEditorialCategoryPageFragment");
const personalEditorialLandingPageQuery = exports.personalEditorialLandingPageQuery = (0, _fetching.gql)`
  query PersonalEditorialLandingPage(
    $pageId: ID!
    $landingPageId: ID
    $includeThemeItems: Boolean! = true
    $includeRoot: Boolean! = false
  ) {
    application {
      ...PersonalEditorialCategoryPage
    }
  }
  ${_personalEditorialCategoryPageFragment.personalEditorialCategoryPageFragment}
`;
